import Types from "../types";

export const signUpEmail = (userInfo) => {
    return { type: Types.SIGNUPWIDTHEMAIL, userInfo }
}

export const keepAliveData = (keepAlive) => {
    return { type: Types.KEEPALIVE, keepAlive };
}

// export const signUpGoogle = (userInfo) => {
//     return { type: Types.SIGNUPWIDTHGOOGLE, userInfo }
// }

// export const changePassword = (msg) => {
//     return { type: Types.CHANGEPASSWORD, msg }
// }

// export const resetPassword = (msg) => {
//     return { type: Types.RESETPASSWORD, msg }
// }
export const isLogin = (payload) => {
    return { type: Types.ISLOGIN, payload }
}

export const saveEmail = (userEmail) => {
    return { type: Types.SAVEEMAIL, userEmail }
}



export const loginIn = (userInfo) => {
    return { type: Types.LOGININ, userInfo }
}

export const loginOut = (msg) => {
    return { type: Types.LOGINOUT, msg }
}

export const sendVerification = (emailToken) => {
    return { type: Types.SENDVERIFICATION, emailToken };
}
